<script lang="ts">

</script>

<section id="global-footer">
    <div class="global-footer-area">
        <div class="global-footer__title">Ryosuke Support Project Executive Committee</div>
        <div class="global-footer__content">
            <div class="global-footer__item">
                <div class="global-footer__item-left">Chairman</div>
                <div class="global-footer__item-right">Tomohumi Yamada</div>
            </div>
            <div class="global-footer__item">
                <div class="global-footer__item-left">Director</div>
                <ul class="global-footer__item-right">
                    <li class="item">Sakae Arakawa</li><li class="item">Shizuko Yamada</li><li class="item">Kazunori Sawada</li>
                    <li class="item">Keisuke Tanaka</li><li class="item">Takumi Shimizu</li><li class="item">Sotaro Yamauchi</li>
                </ul>
            </div>
            <div class="global-footer__item">
                <div class="global-footer__item-left">Supervisor</div><div class="global-footer__item-right">Hanabusho Rhythmic Gymnastics Club</div>
            </div>
            <div class="global-footer__item">
                <div class="global-footer__item-left">Cooperate</div>
                <ul class="global-footer__item-right">
                    <li class="item">Keiko Shina</li>
                    <li class="item">Ayako Shimizu</li>
                    <li class="item">Naoko Nishina</li>
                    <li class="item">Hiromi Matsumoto</li>
                    <li class="item">Wataru Ito</li>
                    <li class="item">Huya Tateyama</li>
                    <div class="annotation">※Article, Photo, Video, GoFundMe, etc</div>
                </ul>
            </div>
        </div>
        <div class="global-footer__bottom-message">This activity is carried out with the approval of Professor Yoshimitsu Nakata and Professor Takehiro Saito of Aomori University, and Teachers Yusuke Osaka and Shohei Shibata of Aomori Yamada High.</div>
    </div>
</section>

<style>
    #global-footer {
        padding:          40px 0;
        background-color: #333333;
        color:            white;
    }

    .global-footer-area {
        width:  1024px;
        margin: 0 auto;
    }
    
    .global-footer__title {
        font-size:     20px;
        font-weight:   bold;
        margin-bottom: 16px;
    }

    .global-footer__content {
        width:            680px;
        margin:           0 auto 16px;
        padding:          16px 8px 8px;
        background-color: white;
        color:            #333333;
        border-radius:    8px;
    }
    
    .global-footer__item {
        display:       block;
        margin-bottom: 8px;
    }
    
    .global-footer__item:nth-child(4) {
        margin-bottom: 16px;
    }

    .global-footer__item-left {
        display:        inline-block;
        width:          104px;
        font-weight:    bold;
        text-align:     left;
        vertical-align: top;
    }

    .global-footer__item-right {
        display:     inline-block;
        width:       480px;
        font-weight: bold;
        margin:      0;
        padding:     0;
        text-align:  left;
    }

    .global-footer__item-right .item {
        display:    inline-block;
        width:      160px;
        list-style: none;
    }
    
    .global-footer__item-right .annotation {
        display:     inline-block;
        font-size:   14px;
        font-weight: normal;
    }
</style>